export default __webpack_public_path__ + "static/media/banner.2fc3a3ff.png";